document.addEventListener("DOMContentLoaded", function() {
  var accordionTitles = document.querySelectorAll('.accordion-title');

  accordionTitles.forEach(function(title) {
    title.addEventListener('click', function() {
      var paragraph = this.nextElementSibling; // Get the next sibling element (accordion-paragraph)

      // Toggle the 'active' class on the accordion-title
      this.classList.toggle('active');

      // Toggle the 'active' class on the accordion-paragraph
      paragraph.classList.toggle('active');
    });
  });
});




  (function(w, d, t, h, s, n) {
    w.FlodeskObject = n;
    var fn = function() {
      (w[n].q = w[n].q || []).push(arguments);
    };
    w[n] = w[n] || fn;
    var f = d.getElementsByTagName(t)[0];
    var v = '?v=' + Math.floor(new Date().getTime() / (120 * 1000)) * 60;
    var sm = d.createElement(t);
    sm.async = true;
    sm.type = 'module';
    sm.src = h + s + '.mjs' + v;
    f.parentNode.insertBefore(sm, f);
    var sn = d.createElement(t);
    sn.async = true;
    sn.noModule = true;
    sn.src = h + s + '.js' + v;
    f.parentNode.insertBefore(sn, f);
  })(window, document, 'script', 'https://assets.flodesk.com', '/universal', 'fd');

  window.fd('form', {
    formId: '69654f5ba878abc2798b1334'
  });

